<template>
  <section class="mb-20">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-900 mb-4">选择测评视角</h2>
      <p class="text-lg text-gray-600 max-w-2xl mx-auto">
        提供两种测评视角，您可以评估自己或帮助了解恋人的占有欲特点
      </p>
    </div>

    <div class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <!-- 给自己测卡片 -->
      <div class="card relative overflow-hidden group hover:shadow-xl transition-all duration-300">
        <!-- 推荐标签 -->
        <div class="absolute top-4 right-4">
          <div class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-psychology-primary text-white border-transparent">
            推荐
          </div>
        </div>

        <div class="p-6">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-12 h-12 bg-psychology-primary/10 rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-primary">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            </div>
            <div>
              <div class="font-semibold text-xl text-psychology-primary">给自己测</div>
              <p class="text-sm text-gray-600">深入了解自己的占有欲程度</p>
            </div>
          </div>

          <div class="space-y-3 mb-6">
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">控制欲望</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">嫉妒强度</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">情感依赖</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">关系不安全感</span>
            </div>
          </div>

          <div class="bg-psychology-primary/5 p-4 rounded-lg mb-6">
            <div class="flex justify-between items-center mb-2">
              <span class="text-sm font-medium">预计用时</span>
              <span class="text-sm text-psychology-primary font-bold">10-15 分钟</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm font-medium">题目数量</span>
              <span class="text-sm text-psychology-primary font-bold">40 题</span>
            </div>
          </div>

          <button @click="handleStartAssessment('self')" class="w-full bg-psychology-primary hover:bg-psychology-primary/90 text-white py-3 px-4 rounded-md font-medium transition-colors flex items-center justify-center gap-2">
            开始自我测评
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 为恋人测卡片 -->
      <div class="card relative overflow-hidden group hover:shadow-xl transition-all duration-300">
        <div class="p-6">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-12 h-12 bg-psychology-secondary/10 rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-secondary">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div>
              <div class="font-semibold text-xl text-psychology-secondary">为恋人测</div>
              <p class="text-sm text-gray-600">了解恋人对您的占有欲程度</p>
            </div>
          </div>

          <div class="space-y-3 mb-6">
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">恋人控制欲望量表</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">恋人嫉妒强度量表</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">恋人情感依赖量表</span>
            </div>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
              <span class="text-sm">恋人关系不安全感量表</span>
            </div>
          </div>

          <div class="bg-psychology-secondary/5 p-4 rounded-lg mb-6">
            <div class="flex justify-between items-center mb-2">
              <span class="text-sm font-medium">预计用时</span>
              <span class="text-sm text-psychology-secondary font-bold">10-15 分钟</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm font-medium">题目数量</span>
              <span class="text-sm text-psychology-secondary font-bold">40 题</span>
            </div>
          </div>

          <button @click="handleStartAssessment('partner')" class="w-full border-2 border-psychology-secondary text-psychology-secondary hover:bg-psychology-secondary hover:text-white py-3 px-4 rounded-md font-medium transition-colors flex items-center justify-center gap-2">
            开始恋人测评
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'TestTypeSection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment(type) {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转
        this.$router.push(`/assessment/start?type=${type}`)
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = `/assessment/start?type=${type}`
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>

